import configData from '../../config.json';
import httpClient from './httpClient';

export async function fetchWatchData(token) {
  const response = await httpClient.get('/WatchData/', {
    token,
    query: {
      'subscription-key': configData.subscriptionkey,
    },
    responseType: 'json',
  });

  return {
    ...response,
  };
}

export async function generateAssociationCode(token) {
  const response = await httpClient.get('/GenerateCode/', {
    token,
    query: {
      'subscription-key': configData.subscriptionkey,
    },
    headers: {
      'X-Brand': 'TUDOR',
      'X-CardType': 'ServiceCard',
    },
    responseType: 'json',
  });

  return {
    ...response,
  };
}
